import styled from "styled-components";
import C from "@assets/themes/colors";

interface IStyleProps {
  enableValue?: boolean;
  isNavigating?: boolean;
}

export const Root = styled.div`
  position: absolute;
  top: -72px;
  right: -40px;
  width: 851px;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.88;
  padding: 36px 35px 20px 36px;
`;

export const TopContent = styled.div`
  display: flex;
  padding: 0px 38px;
  height: 70px;
`;

export const ComboColumnContainer = styled.div`
  width: 235px;
  margin-right: 25px;
`;

export const ComboTitle = styled.div`
  color: ${C.DARK_GRAY};
  margin-bottom: 12px;
`;

export const MiddleContent = styled.div`
  padding: 30px 0px;
`;

export const NavigationContainer = styled.div`
  display: flex;
  height: 14px;
  font-size: 14px;
  font-weight: bold;
  color: ${(props: IStyleProps) => (props.isNavigating ? C.DARK_GRAY : C.DARK_BLUE)};
  padding: 0px 35px 12px;
`;

export const NavigationItemContainer = styled.div`
  display: flex;
`;

export const NavigationItem = styled.div`
  cursor: ${(props: IStyleProps) => (props.enableValue ? 'pointer' : "auto")};
  padding: 0px 5px;
`;

export const NavigationDivider = styled.div`
`;

export const EmptyFolderContainer = styled.div`
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EmptyFolderMessage = styled.p`
  width: 410px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.79;
  color: ${C.DARK_GRAY};
`;

export const BottomContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 0px 29px 39px;
`;

export const ActionsContainer = styled.div`
  display: flex;
`;

export const WarningMessageContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  max-width: 410px;
  max-height: 60px;
  bottom: 28px;
  right: 360px;
`;

export const WarningMessage = styled.p`
  min-width: 230px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.67;
  color: ${C.WHITE};
  border-radius: 5px;
  background-color: ${C.DARKEST_GRAY};
`;

export const NotAllowedCollectionMessage = styled.p`
  width: 410px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.79;
  color: ${C.DARK_GRAY};
`;